
export function createPageUrl(path: string) {
    const [pagePath, queryPart] = path.split('?');
    const formattedPath = '/' + pagePath.toLowerCase().replace(/ /g, '-');
    return queryPart ? `${formattedPath}?${queryPart}` : formattedPath;
}